/**
 * Extracts the inner HTML of a section from a given HTML string using a selector.
 *
 * @param {string} html - The HTML string to parse.
 * @param {string} selector - The CSS selector to find the section.
 * @returns {string} The inner HTML of the selected section.
 */
export function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
}

/**
 * Provide a consistent url that can handle multiple sections, changes in the variant property
 * @param {Array[Object]} sectionsToRender - sections that you will render
 * @param {string} nextVariantId - variant id
 * @returns {string} - a HTTPS url
 */
export function buildSectionUrl(sectionsToRender, nextVariantId = null) {
  return `
    ${window.location.pathname.replace(/\/\//g, '/')}${window.location.search ? `${window.location.search}&` : '?'}${
      nextVariantId ? `variant=${nextVariantId}&` : ''
    }sections=${sectionsToRender.map((sectionItem) => sectionItem.section).join(',')}`;
}
